import { gql } from '@apollo/client'
import { IMAGE_FRAGMENT } from '../fragments'

export const SABRE_CREATE_IMAGE = gql`
  mutation CreateImage($input: CreateImageInput!) {
    createImage(input: $input) {
      image {
        ...Image
      }
    }
  }
  ${IMAGE_FRAGMENT}
`
